import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import {
    ButtonClickAemModel,
    ButtonClickTrackingInfo,
} from "@services/tracking/types/trackingInfo/buttonClickTrackingInfo";

import { EventTypes } from "../types/eventTypes";
import { getPageInfo, getUserInfo } from "./pageImpressionTracker";
import { getEventName, getJsonPayload, hasTrackingEventSuffix } from "./utils";

const getPlacement = (element: HTMLElement) => {
    const closestSection = element.closest("section[data-tracking-info]");
    const placement = closestSection
        ? getJsonPayload(closestSection as HTMLElement)?.name
        : "";
    return placement;
};

const getAnchorTrackingInfo = (
    element?: HTMLAnchorElement,
): ButtonClickAemModel => {
    const model: ButtonClickAemModel = {
        category: element?.className || "",
        name: element?.title || element?.innerText || "",
        targetUrl: element?.href || "",
        targetName: element?.href || "",
    };

    return model;
};

const trackClick = (
    eventName: string,
    placement: string,
    aemModel: ButtonClickAemModel,
): void => {
    const event: TypedAnalyticsEvent<ButtonClickTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: {
                placement: placement,
                ...aemModel,
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

const trackClickInteraction = (
    element: HTMLElement,
    anchorElement?: HTMLAnchorElement,
): void => {
    const aemModel: ButtonClickAemModel = {
        ...getAnchorTrackingInfo(anchorElement),
        ...getJsonPayload(element),
    };
    trackClick(getEventName(element), getPlacement(element), aemModel);
};

const trackClickInteractionWithoutContext = (
    element: HTMLAnchorElement,
): void => {
    const model: ButtonClickAemModel = getAnchorTrackingInfo(element);
    let eventName: string = EventTypes.LinkClick;
    let placement = "";

    const closestSection = element.closest("section[data-tracking-info]");
    if (closestSection && hasTrackingEventSuffix(element, "-click")) {
        eventName = getEventName(closestSection as HTMLElement);
        placement = getPlacement(closestSection as HTMLElement);
    }

    trackClick(eventName, placement, model);
};

export { trackClickInteraction, trackClickInteractionWithoutContext };
